import { getUserInfo } from '../auth/asyncThunks';

export const getUserInfoBuilder = builder => {
  builder.addCase(getUserInfo.fulfilled, (state, { payload }) => {
    const { user } = payload;
    state.user = user;
  });
};
